import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';
import loading from './Components/img/loader.gif';
import Dia_regular from './assets/fonts/e-Ukraine_font/web/e-Ukraine-Regular.woff2';

const dia = `${Dia_regular}`;

const dia_regular = {
  fontFamily: 'Dia_Regular',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Dia_Regular'),
    local('Dia_Regular-Regular'),
    url(${Dia_regular}) format('woff2')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
console.log(dia_regular);
const theme = createTheme({
  typography: {
    fontFamily: 'Dia_Regular, Roboto',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [dia_regular],
      },
    },
  },
});

class StartApp extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000));
  }

  componentDidMount() {
    this.authenticate().then(() => {
      setTimeout(() => {
        this.setState({ loading: true });
      }, 2000);
      // }
    });
    this.setState({ loading: false });
  }

  render() {
    let StartingApp = null;

    if (this.state.loading) {
      StartingApp = <App className="app" />;
    } else {
      StartingApp = (
        <div className="start-loading text-center mt-5">
          <h4
            className="text-title text-center loader-text"
            style={{ color: '#377233', margin: '0 0 8px' }}
          >
            ДП "ІОЦ МІНСОЦПОЛІТИКИ УКРАЇНИ"
          </h4>
          <img src={`${loading}`} alt="loading" />
        </div>
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ReactCSSTransitionGroup
          transitionName="app"
          transitionAppear
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}
          transitionEnterTimeout={500}
          transitionEnter
          transitionLeave
        >

          {StartingApp}
        </ReactCSSTransitionGroup>
      </ThemeProvider>
    );
  }
}

ReactDOM.render(<StartApp />, document.getElementById('root'));

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
